"use strict";

var AccountApi = require("../api/AccountApi");

var ApiHelper = require("../shared/ApiHelper");
var HtmlHelper = require("../shared/HtmlHelper");
var InputHelper = require("../shared/InputHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");
var ReactHelper = require("../shared/ReactHelper");

var BillingAddressHelper = require("../accountComponents/BillingAddressHelper");

var PaymentHelper = require("../commonComponents/PaymentHelper");

var myRecurringSelector = "[data-component='myRecurring']";
var myRecurringDonationEditDonationAmountSelector = "[data-component='myRecurringDonations.edit.donationAmount']";
var myRecurringPopulatedSingleRecurringSelector = "[data-component='myRecurring.populated.singleRecurring']";
var myRecurringDonationsSelector = "[data-component='myRecurringDonations']";
var myRecurringHeaderSelector = "[data-component='myRecurringHeader']";
var myRecurringPaymentSelector = "[data-component='myRecurringPayment']";
var SmartyStreets = require("./SmartyStreets");

var MyRecurringRefresh = {
	initializeMyRecurring: function($component) {
		InputHelper.initializeAmountInput($component || $(myRecurringSelector), myRecurringDonationEditDonationAmountSelector);
	},

	replaceMyRecurringSubComponent($allData, $newData, $currentSingleRecurring, selector) {
		if ($newData.length) {
			//Need to append and run react component initialize scripts
			$newData.append($allData.filter("script"));

			//We need to find the specific donation that we are trying to replace
			if (selector.includes("data-donation-id")) {
				selector = selector.replace("[data-donation-id]", `[data-donation-id='${$newData.attr("data-donation-id")}']`);
			}

			var $oldData = $currentSingleRecurring.find(selector);

			if ($oldData.length) {
				HtmlHelper.addIdToDataComponents($newData);

				//Unmount existing react components
				$oldData.find("[data-react-component-name]").each(function() {
					ReactHelper.unmountElement(this.parentElement);
				});

				$oldData.replaceWith($newData);
				this.initializeMyRecurring($newData);

				HtmlHelper.focusAndSelectFirstField($newData);
			}
		}
	},

	getMyRecurringHtml: function(event, isEditing, options) {
		var deferred = new $.Deferred();

		var $currentRecurring = $(event.target).closest(myRecurringPopulatedSingleRecurringSelector);

		var myRecurringId = $currentRecurring.attr("data-recurring-id");
		var myRecurringComponentId = $currentRecurring.closest(myRecurringSelector).attr("id");

		AccountApi.myRecurringGetRecurring(myRecurringId, {
			donationId: options.donationId,
			isEditing,
			myRecurringComponentId,
			usingDonations: options.usingDonations,
			usingHeader: options.usingHeader,
			usingPayment: options.usingPayment
		}).done((data) => {
			var $data = $(data);

			var $newHeader = $data.find(myRecurringHeaderSelector);
			var $newPayment = $data.find(myRecurringPaymentSelector);
			var $newDonation = $data.find(`${myRecurringDonationsSelector} [data-donation-id]`);

			//Recurring id is already added to the header form on save.
			//RecurringId is being added to payment / donations forms here to prevent the users from having to resave layouts or apply breaking changes to get this fix.
			//Add recurring id to the forms
			var $paymentForms = $newPayment.find("form#editRecurringPaymentForm");
			$paymentForms.each((index, paymentForm) => {
				var $paymentForm = $(paymentForm);

				var newPaymentFormId = `${$paymentForm.attr("id")}-${myRecurringId}`;
				HtmlHelper.setUniqueFormId($paymentForm, newPaymentFormId);
			});

			var $donationForms = $newDonation.find("form#editRecurringDonation");
			$donationForms.each((index, donationForm) => {
				var $donationForm = $(donationForm);
				var donationId = $donationForm.closest("[data-component='myRecurringDonations.edit']").attr("data-donation-id");

				var newDonationFormId = `${$donationForm.attr("id")}-${donationId}`;
				HtmlHelper.setUniqueFormId($donationForm, newDonationFormId);
			});

			this.replaceMyRecurringSubComponent($data, $newHeader, $currentRecurring, myRecurringHeaderSelector);
			this.replaceMyRecurringSubComponent($data, $newPayment, $currentRecurring, myRecurringPaymentSelector);
			this.replaceMyRecurringSubComponent($data, $newDonation, $currentRecurring, `${myRecurringDonationsSelector} [data-donation-id]`);

			SmartyStreets.initializeMyRecurringsBillingAddressesAdd(myRecurringId);

			// Apply a new `id` to the Billing Address Add Form being added to the DOM since it is in a repeater and doesn't have one.
			// We use HtmlHelper.getId() here so that we don't apply `id`s to all nested components.
			var $billingAddressAddForm = $newPayment.find("[data-component='billingAddress.addForm']");
			var newFormId = HtmlHelper.getId($("body"));
			$billingAddressAddForm.attr("id", newFormId);

			//Re-apply Billing Address listeners
			window.PostalCodeHelper.addCountryChangeListeners($billingAddressAddForm);
			BillingAddressHelper.initialize({
				billingAddressAddFormSelector: $billingAddressAddForm
			});

			PaymentHelper.initializePaymentComponent($newPayment);

			deferred.resolve($data);
		}).fail((jqXHR, textStatus) => {
			this._resolveError(jqXHR, textStatus, deferred);
		});

		return deferred;
	},

	_resolveError(jqXHR, textStatus, deferred) {
		if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
			//There was not a partial error, so do what we normally would do.
			ApiHelper.displayErrorMessage(jqXHR);
		}

		if (deferred) {
			deferred.reject(jqXHR, textStatus);
		}
	}
};

module.exports = MyRecurringRefresh;
